const Query = (query, variables) => {
  const url = '/api_proxy'
  const method = 'POST'
  const body = JSON.stringify({ query, variables })
  const headers = { 'Content-Type': 'application/json' }

  return fetch(url, { method, body, headers }).then(res => res.json())
}

// TODO: Implement mutation if needed
const Mutation = () => null

export {
  Query,
  Mutation
}
